import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import './Step5DriverInfo.scss';
import InsuranceSection from './components/InsuranceSection';
import StatusSection from './components/StatusSection';
import DatesSection from './components/DatesSection';
import CarrierEmailsSection from './components/CarrierEmailsSection';
import CarrierSelectionSection from './components/CarrierSelectionSection';
import PhotosSection from './components/PhotosSection';
import DocumentsSection from './components/DocumentsSection';
import PaymentSection from './components/PaymentSection';
import SendFilesModal from './components/SendFilesModal';
import { CustomIcon } from '../../../UI';

const Step5DriverInfo = ({ readOnly = false, loadId = null }) => {
  const { watch } = useFormContext();
  const [carriersList, setCarriersList] = useState([]);
  const [sendFilesModalOpen, setSendFilesModalOpen] = useState(false);
  const status = watch('status');

  useEffect(() => {
    if (status === 'Listed') {
      setCarriersList([]);
    }
  }, [status]);

  const handleCarrierAdded = (carrierData) => {
    if (readOnly) return;
    if (carrierData.email) {
      setCarriersList(prev => {
        if (!prev.includes(carrierData.email)) {
          return [...prev, carrierData.email];
        }
        return prev;
      });
    }
  };

  return (
    <div className="step-5-driver-info">
      <fieldset disabled={readOnly}>
        <CarrierSelectionSection onCarrierAdded={handleCarrierAdded} />
        <CarrierEmailsSection availableEmails={carriersList} />
        <InsuranceSection />
        <StatusSection />
        <DatesSection />
        <PaymentSection />
        <PhotosSection />
        <DocumentsSection loadId={loadId} />
        {!readOnly && (
          <div className="step-5-send-files-wrap">
            <button
              type="button"
              className="step-5-send-files-btn"
              onClick={() => setSendFilesModalOpen(true)}
            >
              <CustomIcon name="file-attach-02" size={20} />
              Send files
            </button>
          </div>
        )}
      </fieldset>
      <SendFilesModal
        isOpen={sendFilesModalOpen}
        onClose={() => setSendFilesModalOpen(false)}
        loadId={loadId}
      />
    </div>
  );
};

export default Step5DriverInfo;
